import $ from 'jquery';
import cookie from 'react-cookies';
import * as globalUtils from '../../Global/global_js';
import * as  indexUtils from '../js/index';
var logo_image_guid = "";
var error_info = "";
var video_guid = "";
export function update_settings(t)
{
    video_guid = t.state.videoData.videoGuid;
    try
    {
        t.props.toggleBlocking(true);
        if (t.state.videoDesignSettingDiv.show_homepage === true && t.state.videoDesignSettingDiv.homepage_link === "")
        {
            t.showToast("Please enter home page url", "error");
            t.props.toggleBlocking(false);
        }
        else if (t.state.videoDesignSettingDiv.homepage_link !== "" && (t.state.videoDesignSettingDiv.homepage_link.indexOf("http://") === -1 &&
            t.state.videoDesignSettingDiv.homepage_link.indexOf("https://") === -1))
        {
            t.showToast("Home page url must start with http:// or https://", "error");
            t.props.toggleBlocking(false);
        }
        else
        {
            if (t.state.videoDesignSettingDiv.videoLogoFile !== undefined && t.state.videoDesignSettingDiv.videoLogoFile !== "")
            {
                upload_image(t, t.state.videoDesignSettingDiv.logo_src, t.state.videoDesignSettingDiv.videoLogoFile);
            }
            else
            {
                logo_image_guid = t.state.videoDesignSettingDiv.logo_guid;
                continue_save_admin_setting(t);
            }
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("save_settings.js",
            "update_settings",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function upload_image(t, data, image_file)
{
    try
    {
        var parameters = {
            account_guid: t.state.videoData.userGuid,
            base64_string: data,
            file_name: image_file.name,
            image_name: image_file.name,
            error_info: ""
        };
        $.ajax({
            url: "/api/HData/upload_image/data",
            type: 'POST',
            data: JSON.stringify(parameters),
            async: true,
            contentType: 'application/json',
            dataType: "text",
            success: function (response)
            {
                if (response !== undefined && response !== null)
                {
                    logo_image_guid = response.split(",")[0];
                    continue_save_admin_setting(t);
                }
                else
                {
                    t.showToast("An error ocurred please contact admin", "error");
                }

            },
            error: function (ex)
            {
                t.showToast("An error ocurred please contact admin", "error");
            }
        });
    }
    catch (ex)
    {
        globalUtils.send_error_fun("save_settings.js",
            "upload_image",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function continue_save_admin_setting(t)
{
    try
    {
        t.props.toggleBlocking(true);
        var account_guid_ = t.state.videoData.userGuid;
        var api_link = localStorage.getItem("api_url") + "react_insert_update_PDS_template_one_setting_for_all_vods";
        var homepage_link = t.state.videoDesignSettingDiv.homepage_link ;
        if (homepage_link == "")
        {
            homepage_link = "a";
        }
        var video_settings = t.state.videoDesignSettingDiv;
        var parameters =
        {
            player_guid: video_settings.player_guid,
            account_guid: account_guid_,
            video_guid: t.state.videoData.videoGuid,
            video_type: t.state.videoData.videoType,
            logo_image: logo_image_guid,
            show_chat: video_settings.show_chat,
            
            show_description: "true",
            show_comments: video_settings.show_comments,
            show_facebook_comments: video_settings.show_fb_comments,
            show_title: "true",
            show_player_logo_title: "true",
            
            show_reference: video_settings.show_references,
            show_download: video_settings.show_download,
            show_logo: video_settings.show_logo,

            show_bookmarks: video_settings.show_bookmarks,
            show_homepage: video_settings.show_homepage,
            homepage_link: homepage_link,
            hls_low_delay: video_settings.hls_low_delay,
            visitor_timeout: video_settings.visitor_timeout,
            is_dark: video_settings.is_dark,
            error_info: error_info
        };

        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: true,
            dataType: "json",
            success: function (response)
            { save_player_design_success(t, response); },
            error: function (response) { save_player_design_error(t, response); }
        });
    }
    catch (ex)
    {
        t.showToast("Error occured please contact admin.", "error");
        t.props.toggleBlocking(false);
        globalUtils.send_error_fun("save_settings.js",
            "continue_save_admin_setting",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function save_player_design_success(t, response)
{
    try
    {

        if (response != null && response != false)
        {
            // here will get the player design 
            t.props.load_video_info();
            t.props.onCloseDrawerClick();
        }
        else
        {
            t.showToast("Error occured please contact admin.", "error");
            t.props.toggleBlocking(false);
        }
    }
    catch (ex)
    {
        t.showToast("Error occured please contact admin.", "error");
        t.props.toggleBlocking(false);
        globalUtils.send_error_fun("save_settings.js",
            "save_player_design_success",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function save_player_design_error(t, ex)
{
    t.showToast("Error occured please contact admin.", "error");
    t.props.toggleBlocking(false);
    globalUtils.send_error_fun("save_settings.js",
        "save_player_design_error",
        ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
}